import type { MouseEventHandler } from 'react';
import { Center } from '@mantine/core';
import { forwardRef } from 'react';

import { IconFigmaMoreHorizontal } from '@/assets/icons';

interface KebabTriggerProps {
  onClick?: MouseEventHandler<HTMLDivElement>;
}

/** Zajednički "..." gumb za Menu.Target — jedan vizualni izvor istine za akcijski izbornik reda
 * (stavke Cjenika, Jedinice, Timovi, linije Ponude, korisnici u Roles, RowActionsMenu), umjesto
 * dupliciranog stila po datoteci. forwardRef je NUŽAN — Menu.Target klonira dijete i prosljeđuje
 * mu ref da izračuna poziciju dropdowna; obična funkcijska komponenta bez njega uzrokuje da se
 * izbornik otvori u (0,0), gornji lijevi kut ekrana, umjesto uz sam gumb. */
export const KebabTrigger = forwardRef<HTMLDivElement, KebabTriggerProps>(({ onClick }, ref) => (
  <Center
    ref={ref}
    w={32}
    h={32}
    onClick={onClick}
    style={{
      borderRadius: 6,
      backgroundColor: 'var(--color-bg-canvas)',
      cursor: 'pointer'
    }}
  >
    <IconFigmaMoreHorizontal size={16} />
  </Center>
));

KebabTrigger.displayName = 'KebabTrigger';
